var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00677 10.1856L1.43927 5.49997L6.00677 0.81434C6.08854 0.730623 6.13432 0.61824 6.13432 0.501215C6.13432 0.384189 6.08854 0.271806 6.00677 0.18809C5.96705 0.147554 5.91965 0.115351 5.86733 0.0933667C5.81501 0.0713823 5.75883 0.0600586 5.70208 0.0600586C5.64533 0.0600586 5.58915 0.0713823 5.53683 0.0933667C5.48451 0.115351 5.43711 0.147554 5.39739 0.18809L0.537395 5.17278C0.45207 5.26032 0.404316 5.37772 0.404316 5.49997C0.404316 5.62221 0.45207 5.73962 0.537395 5.82715L5.39645 10.8118C5.4362 10.8527 5.48372 10.8851 5.53621 10.9073C5.58871 10.9294 5.6451 10.9408 5.70208 10.9408C5.75905 10.9408 5.81545 10.9294 5.86794 10.9073C5.92044 10.8851 5.96796 10.8527 6.0077 10.8118C6.08948 10.7281 6.13525 10.6157 6.13525 10.4987C6.13525 10.3817 6.08948 10.2693 6.0077 10.1856L6.00677 10.1856Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessSign);
export default __webpack_public_path__ + "static/media/lessSign.43a9357e2c0ec7ba9e1eb24796578332.svg";
export { ForwardRef as ReactComponent };